import type CncAdPosition from "~/libs/interfaces/CncAdPosition"
import type ArticleFilters from "~/libs/interfaces/ArticleFilters"
import {ARTICLE_QUERY_TYPE, useArticlesStore} from "~/stores/useArticlesStore";
import type ArticleLocal from "~/libs/interfaces/ArticleLocal";

type ArticlesStore = ReturnType<typeof useArticlesStore>

const ADS_TEXT_KEYWORD = 'reklama'
export const useAdsApi = (store: ArticlesStore, payload?: CncAdPosition) => {
  const logger = useFrontendLogger()

  const getFilters = (): ArticleFilters => {
    const apiIdToUuid = useApiIdConverter().apiIdToUuid

    const ids: string[] = []
    if (payload?.imageArticleId) {
      ids.push(apiIdToUuid(payload?.imageArticleId) as string)
    }
    if (payload?.imageRetinaArticleId) {
      ids.push(apiIdToUuid(payload?.imageRetinaArticleId) as string)
    }
    return {
      ids
    }
  }

  const fetch = () => {
    const filters = getFilters()
    store.setLimit(2)
    store.fetchArticles(filters, ARTICLE_QUERY_TYPE.DETAIL, {
      forceRefetch: false,
      useDefaultFilters: false,
      usePublishedStateFilters: false,
    })
  }

  const getArticle = () => {
    let article = null
    if (payload?.imageArticleId) {
      article = store.articles.find((article: ArticleLocal) => article.id === payload?.imageArticleId)
    }
    if (!article && payload?.imageRetinaArticleId) {
      article = store.articles.find((article: ArticleLocal) => article.id === payload?.imageRetinaArticleId)
    }
    return article
  }


  const getMainImageUrl = () => {
    let article = null
    if (payload?.imageArticleId) {
      article = store.articles.find((article: ArticleLocal) => article.id === payload?.imageArticleId)
    }
    if (!article && payload?.imageRetinaArticleId) {
      article = store.articles.find((article: ArticleLocal) => article.id === payload?.imageRetinaArticleId)
    }
    if (article?.previewAsset?.urlWithProtocol) {
      return article?.previewAsset?.urlWithProtocol
    }
    return undefined
  }

  const getImageSet = () => {
    const imageSet = []
    if (payload?.imageArticleId) {
      const article = store.articles.find((article: ArticleLocal) => article.id === payload?.imageArticleId)
      if (article?.previewAsset?.urlWithProtocol) {
        imageSet.push(`${article?.previewAsset?.urlWithProtocol} 1x`)
      }
    }
    if (payload?.imageRetinaArticleId) {
      const article = store.articles.find((article: ArticleLocal) => article.id === payload?.imageRetinaArticleId)
      if (article?.previewAsset?.urlWithProtocol) {
        imageSet.push(`${article?.previewAsset?.urlWithProtocol} 2x`)
      }
    }

    if (imageSet.length) {
      return imageSet.join(', ')
    }
    return undefined
  }

  const showAdsText = () => {
    const article = getArticle()
    const keywords = article?.keywords?.map((keyword: string) => keyword.toLowerCase())
    return !!(article && keywords?.includes(ADS_TEXT_KEYWORD))
  }

  const getLink = () => {
    const article = getArticle()
    if (article?.jsonBodyDecoded?.at(0)?.contentHTML) {
      return useHtmlToPlainText(article?.jsonBodyDecoded?.at(0)?.contentHTML)
    }
    return payload?.link
  }

  return {
    getFilters,
    fetch,
    getMainImageUrl,
    getImageSet,
    showAdsText,
    getLink,
  }
}